/** @format */
import jQuery from 'jquery';
import select2 from 'select2';
select2(jQuery);

jQuery(function($) {
    $('.c-news-header__filter-bar .select2-field').select2({
        placeholder: "Select an option",
        dropdownParent: $('.c-news-header__filter-bar')
    });
});
